import { useMemo } from 'react';

import { getAccessibilityStatementUrl, getHelpUrl } from '@change-corgi/config/help';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';
import { useRoutes } from 'src/app/shared/hooks/routes';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useSupportLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const routes = useRoutes();
	const locale = useLocale();

	const links = useMemo(() => {
		const accessibilityStatementUrl = getAccessibilityStatementUrl(locale);
		return [
			{
				href: getHelpUrl(locale),
				title: translate('fe.components.footer.help'),
			},
			...(locale !== 'en-US'
				? [
						{
							href: routes.guides,
							title: translate('fe.components.footer.guides'),
						},
					]
				: []),
			{ href: '/policies/privacy', title: translate('fe.components.footer.privacy') },
			{ href: '/policies/terms-of-service', title: translate('fe.components.footer.terms') },
			...(accessibilityStatementUrl
				? [{ href: accessibilityStatementUrl, title: translate('fe.components.footer.accessibility_statement') }]
				: []),
			{ href: '/policies/cookies', title: translate('fe.components.footer.cookies') },
			{ href: '/u/manage_cookies', title: translate('fe.components.footer.manage_cookies') },
		];
	}, [locale, routes, translate]);

	return processLinkGroup({
		title: translate('fe.components.footer.support'),
		links,
	});
}
